// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_GgF","cls2":"ClaimEvaluationRow-cls2_nCz ClaimEvaluationRow-cls1_GgF"};